import api from './api.ts';

export interface MfaStatus {
  mfaEnabled: boolean;
  enabledAt: string | null;
  backupCodesRemaining: number;
  backupCodesGeneratedAt: string | null;
}

export interface MfaSetupPayload {
  secret: string;
  secretFormatted: string;
  otpauthUrl: string;
  qrDataUrl: string;
}

export async function fetchMfaStatus(): Promise<MfaStatus> {
  const res = await api.get('/auth/mfa/status');
  return (res.data?.data || res.data) as MfaStatus;
}

export async function startMfaSetup(): Promise<MfaSetupPayload> {
  const res = await api.post('/auth/mfa/setup/start');
  return (res.data?.data || res.data) as MfaSetupPayload;
}

export async function confirmMfaSetup(
  code: string
): Promise<{ backupCodes: string[]; enabledAt: string }> {
  const res = await api.post('/auth/mfa/setup/confirm', { code });
  return (res.data?.data || res.data) as { backupCodes: string[]; enabledAt: string };
}

export async function regenerateBackupCodes(
  password: string,
  code: string
): Promise<{ backupCodes: string[]; generatedAt: string }> {
  const res = await api.post('/auth/mfa/backup/regenerate', { password, code });
  return (res.data?.data || res.data) as { backupCodes: string[]; generatedAt: string };
}

export async function disableMfa(password: string, code: string): Promise<void> {
  await api.post('/auth/mfa/disable', { password, code });
}

export async function verifyMfaLogin(
  mfaToken: string,
  code: string
): Promise<{ token: string; user: any }> {
  const res = await api.post('/auth/mfa/verify', { mfaToken, code });
  const payload = res.data?.data || res.data;
  if (!payload?.token || !payload?.user) {
    throw new Error(res.data?.error || 'Resposta MFA inválida');
  }
  return payload;
}

export const MFA_BACKUP_STORAGE_KEY = '@AssetManagement:mfaBackupCodes';
export const MFA_TOKEN_STORAGE_KEY = '@AssetManagement:mfaToken';
export const MFA_EMAIL_STORAGE_KEY = '@AssetManagement:mfaEmail';

export function storeBackupCodesOnce(codes: string[]) {
  sessionStorage.setItem(MFA_BACKUP_STORAGE_KEY, JSON.stringify(codes));
}

export function takeBackupCodesOnce(): string[] | null {
  const raw = sessionStorage.getItem(MFA_BACKUP_STORAGE_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(MFA_BACKUP_STORAGE_KEY);
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function peekBackupCodes(): string[] | null {
  const raw = sessionStorage.getItem(MFA_BACKUP_STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}
